export function useDownload() {
  function downloadXlsxFile(base64Body: string, filename: string) {
    const mediaType = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,';
    const link = document.createElement('a');

    link.href = mediaType + base64Body;
    link.setAttribute('download', `${filename}.xlsx`);
    document.body.appendChild(link);
    link.click();
  }

  return { downloadXlsxFile };
}
